import React from "react";

const TermsOfService = () => (
  <div className="max-w-3xl mx-auto py-12 px-4 md:px-6 lg:px-8">
    <h1 className="text-4xl font-bold text-primary mb-8">Terms of Service</h1>
    <p className="text-gray-700 mb-6">
      By using <strong>ThoughtCode</strong>, you agree to the following terms
      and conditions.
    </p>

    <div className="border-t border-gray-200 pt-6 mt-6">
      <h2 className="text-2xl font-semibold text-gray-900 mb-4">
        Use of Service
      </h2>
      <ul className="list-disc list-inside text-gray-700 space-y-2">
        <li>Use the platform for lawful purposes only.</li>
        <li>Do not misuse or attempt to disrupt the service.</li>
      </ul>
    </div>

    <div className="border-t border-gray-200 pt-6 mt-6">
      <h2 className="text-2xl font-semibold text-gray-900 mb-4">
        Intellectual Property
      </h2>
      <p className="text-gray-700">
        All content and templates are the property of{" "}
        <strong>ThoughtCode</strong> unless otherwise stated.
      </p>
    </div>

    <div className="border-t border-gray-200 pt-6 mt-6">
      <h2 className="text-2xl font-semibold text-gray-900 mb-4">Liability</h2>
      <p className="text-gray-700">
        <strong>ThoughtCode</strong> is not liable for any damages resulting
        from the use of this platform.
      </p>
    </div>

    <p className="text-sm text-gray-500 mt-10 italic">
      Last updated: {new Date().toLocaleDateString()}
    </p>
  </div>
);

export default TermsOfService;
